import { uniqueId } from 'lodash';
import invariant from 'invariant';

const METHODS = ['next', 'prev', 'first', 'last'];

declare const process;

export function validateList(list) {
  if (process?.env?.NODE_ENV !== 'production') {
    METHODS.forEach((method) => invariant(typeof list[method] === 'function', 'List components must implement a `' + method + '()` method'));
  }
}

export function notify(handler, args) {
  handler?.(...[].concat(args));
}

export function instanceId(component, suffix = '') {
  component.__id = component.__id ?? uniqueId('vdl_');
  return (component.props.id || component.__id) + suffix;
}

export function generateId(props, suffix = '') {
  return props.id || (uniqueId('vdl_') + suffix);
}

export function isFirstFocusedRender(component) {
  return component._firstFocus || (component.state.focused && (component._firstFocus = true));
}

let defaultPopupContainerClass = '';

export function getDefaultPopupContainerClass() {
  return defaultPopupContainerClass;
}

export function setDefaultPopupContainerClass(newClass) {
  defaultPopupContainerClass = newClass;
}
